import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';

import styles from './style';
import Menu from '../../../atomic/Menu';
import IconButton from '../../../atomic/IconButton';
import FAQIcon from '../../../../assets/icons/FAQ';
import ListItem from '../../../CardList/ListItem';
import getSettingItems from '../../../../structure/settings';
import useDashboardLinkPrefix from '../../../../hooks/useDashboardLinkPrefix';

const FAQ = ({ classes }) => {
  const dashboardLinkPrefix = useDashboardLinkPrefix();

  const [anchorEl, setAnchorEl] = useState(null);

  const sections = getSettingItems({ dashboardLinkPrefix });
  const section = sections.find(({ supportSection }) => !!supportSection);

  const handleClose = () => setAnchorEl(null);

  const onButtonClick = (event) => setAnchorEl(event.currentTarget);

  const onItemClick = (passedOnClick, event) => {
    if (passedOnClick) {
      passedOnClick(event);
    }

    handleClose();
  };

  return (
    <>
      <IconButton color="primary" onClick={onButtonClick}>
        <FAQIcon className={classes.faqIcon} />
      </IconButton>

      <Menu
        keepMounted
        anchorEl={anchorEl}
        onClose={handleClose}
        open={Boolean(anchorEl)}
      >
        {section.items.map(({ text, onClick, ...props }) => (
          <ListItem
            border={false}
            className={classes.listItem}
            key={`support-list-item-${text}`}
            onClick={(event) => onItemClick(onClick, event)}
            {...props}
          >
            {text}
          </ListItem>
        ))}
      </Menu>
    </>
  );
};

export default withStyles(styles)(FAQ);
